// extracted by mini-css-extract-plugin
export var avatarContainer = "_ib-0";
export var avatarTypingWave = "_ib-i";
export var gray = "_ib-f";
export var green = "_ib-c";
export var icon = "_ib-9";
export var image = "_ib-1";
export var lg = "_ib-6";
export var md = "_ib-5";
export var presenceDot = "_ib-b";
export var red = "_ib-d";
export var sm = "_ib-4";
export var status = "_ib-a";
export var typingDot = "_ib-h";
export var typingPill = "_ib-g";
export var xl = "_ib-7";
export var xs = "_ib-3";
export var xxl = "_ib-8";
export var xxs = "_ib-2";
export var yellow = "_ib-e";